import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";

export default function CartStatus({
  shopUrl,
  title,
  description,
  showButton = true,
  buttonText = "continue_shopping",
  showIcon = true,
}: {
  shopUrl: string;
  title: string;
  description: string;
  showButton?: boolean;
  buttonText?: string;
  showIcon?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex h-[94vh] items-center justify-center px-4 md:px-24">
      <div className="mb-[6vh] flex flex-col items-center justify-center rounded border border-gray-200 bg-white px-28 py-8 text-center">
        {showIcon && (
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-shopping-bag h-8 w-8 text-gray-400"
            >
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
              <path d="M3 6h18"></path>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </div>
        )}
        <h3 className="mb-2 text-lg font-semibold">{title}</h3>
        <p
          className={cn("mb-6 max-w-[240px] text-sm text-gray-600", {
            "mb-0": !showButton,
          })}
        >
          {description}
        </p>
        {showButton && (
          <a
            href={shopUrl}
            className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white"
          >
            {t(buttonText)}
          </a>
        )}
      </div>
    </div>
  );
}
